const getters = {
    sidebar: (state) => {return state.navigation.sidebar},
    title: (state) => {return state.navigation.title},
    header: (state) => {return state.navigation.header},
    user: (state) => {return state.user.user},
    location: (state) => {return state.user.location},
    mobile: (state) => {return  state.navigation.mobile},
    verified: (state) => {return state.user.user.email_verified_at},
    app: (state) => {return state.app.app},
    bottom: (state) => {return state.app.app.bottom},
    colors: (state) => {return state.app.colors},
    notifications: (state) => {return state.notifications.notifications},
    messages: (state) => {return state.app.app.messages},
    websites: (state) => {return state.websites.websites},
    activeWebsite: (state) => {return state.websites.activeWebsite},
    selectWebsite: (state) => {return state.websites.selectWebsite},
    app_info_initialized:(state) => {return state.app.app.app_info_initialized},
    statuses:(state) => {return state.app.app.statuses},
    logo:(state) => {return state.app.app.logo},
    admin_logo:(state) => {return state.app.app.admin_logo},
    contacts:(state) => {return state.contacts.contacts},
    activeContact: (state) => {return state.contacts.activeContact},
    progress: (state) => {return state.app.app.progress},
    colors_swatches: (state) => {return state.app.app.colors_swatches},
};
export default getters;
